import { render, staticRenderFns } from "./HistoryClockIcon.vue?vue&type=template&id=d813cd50&scoped=true&"
import script from "./HistoryClockIcon.vue?vue&type=script&lang=js&"
export * from "./HistoryClockIcon.vue?vue&type=script&lang=js&"
import style0 from "./HistoryClockIcon.vue?vue&type=style&index=0&id=d813cd50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d813cd50",
  null
  
)

export default component.exports